import { useEffect } from 'react';
import { backend } from './backend';
import { fetchCommunityProfiles } from './community-feed';
import { useLive } from './hooks';

export function useCommunityProfiles() {
  const state = useLive(async () => {
    const actor = await backend();
    return fetchCommunityProfiles((offset, limit) => actor.community_updates_v3(offset, limit));
  }, 'all-community-profiles-v3', 15_000);
  useEffect(() => {
    window.addEventListener('soonscreener:community-updated', state.refresh);
    return () => window.removeEventListener('soonscreener:community-updated', state.refresh);
  }, [state.refresh]);
  return state;
}
